module.exports = require("@pb/kit-stylus/stylus.config");